
import React from 'react';
import { ResponseExtractor } from '../../molecules/ResponseExtractor';
import { WorkflowNodeData } from '../../../types';

interface ExtractionTabProps {
    data: WorkflowNodeData;
    onChange: (key: string, value: any) => void;
}

export const ExtractionTab: React.FC<ExtractionTabProps> = ({ data, onChange }) => {
    return (
        <div className="p-6 h-full flex flex-col">
            <ResponseExtractor data={data} onChange={onChange} />
        </div>
    );
};
